
import { RevPicker } from '@ds/components/Picker'

import Picker from '../Picker'

import {
  COLS_CLASS_DEFAULT,
  COLS_CLASS_OVERRIDES,
  DISPLAY_SOLD_OUT,
  MAX_PICKER_ITEMS,
} from './PickerGroup.constants'
import translations from './PickerGroup.translations'

export default {
  components: {
    Picker,
    RevPicker,
  },
  props: {
    picker: {
      type: Object,
      default: () => {},
    },
    variantForSelectedPickers: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      displayAllItems: false,
    }
  },
  computed: {
    translations: () => translations,

    itemsToDisplay() {
      const { items } = this.picker

      if (this.isItemsLengthHigherThanMax && !this.displayAllItems) {
        return items.slice(0, this.maximumAmountOfItemsToShow)
      }

      return items
    },

    isItemsLengthHigherThanMax() {
      return this.picker.items.length > MAX_PICKER_ITEMS
    },

    remainingItemsCount() {
      return this.picker.items.length - this.maximumAmountOfItemsToShow
    },

    maximumAmountOfItemsToShow() {
      return MAX_PICKER_ITEMS - 1
    },

    togglerLabel() {
      const { showMore, showLess } = this.translations

      return this.displayAllItems
        ? this.$t(showLess)
        : this.$t(showMore, { remaining: this.remainingItemsCount })
    },

    pickerTitle() {
      return this.picker.label
    },

    pickerId() {
      return this.picker.id
    },

    gridColumnsClass() {
      return COLS_CLASS_OVERRIDES[this.pickerId] ?? COLS_CLASS_DEFAULT
    },

    shouldDisplaySoldOut() {
      return DISPLAY_SOLD_OUT.includes(this.pickerId)
    },
  },

  methods: {
    toggleDisplayAllItems() {
      this.displayAllItems = !this.displayAllItems
    },
    handleClick(index) {
      this.$emit('change', this.picker.id, index)
    },
  },
}
